import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/contact/mocker'

export default {
  receivedContactsInfiniteLoading (searchParams) {
    if (isMock) return generator(mocker.contacts(searchParams))
    return instance().post(endpoint + '/contact', searchParams)
  },
  receivedFullnames () {
    if (isMock) return generator(mocker.fullnames())
    return instance().get(endpoint + '/contact/fullname')
  },
  receivedCompanies () {
    if (isMock) return generator(mocker.companies())
    return instance().get(endpoint + '/contact/company')
  },
  receivedPositions () {
    if (isMock) return generator(mocker.positions())
    return instance().get(endpoint + '/contact/position')
  },
  postContactFavorite (postParams) {
    if (isMock) return generator(mocker.contactFavorite())
    return instance().post(endpoint + '/contact/favorite', postParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/contact/index.js